import { debounce, isDescendant } from '../utilities';

const $elements = {
	component:      document.querySelector( '#colt-search-dropdown' ),
	trigger:        document.querySelector( '#colt-search-trigger' ),
	dropdown:       document.querySelector( '#colt-search-contents' ),
	form:           document.querySelector( '#colt-search-form' ),
	input:          document.querySelector( '#colt-search-input' ),
	termSelector:   document.querySelector( '#colt-search-term-selector'),
	results:        document.querySelector( '#colt-search-results' ),
	resultTemplate: document.querySelector( '#colt-search-result-template' ),
};

const CLASS_DROPDOWN_HIDDEN = 'search-dropdown__contents--hidden';
const MS_LIVE_SEARCH_DELAY  = 500;
const AJAX_ACTION           = 'colt_search_live_results';

const handleSearchDropdown = () => {

	if ( $elements.dropdown.classList.contains( CLASS_DROPDOWN_HIDDEN ) ) {
		$elements.dropdown.classList.remove( CLASS_DROPDOWN_HIDDEN );
	} else {
		$elements.dropdown.classList.add( CLASS_DROPDOWN_HIDDEN );
	}

};

const maybeCloseSearchDropdown = ( event ) => {

	if ( ! $elements.dropdown.classList.contains( CLASS_DROPDOWN_HIDDEN ) && ! isDescendant( event.target, $elements.component ) ) {
		$elements.dropdown.classList.add( CLASS_DROPDOWN_HIDDEN );
	}

};

const triggerAjaxSearch = ( event ) => {
    
	const request = new XMLHttpRequest();
	const params  = new URLSearchParams();

	let url   = new URL( $elements.form.querySelector( 'input[name="url"]' ).value );
	let query = $elements.input.value;

	params.set( 'action', AJAX_ACTION );
	params.set( 'nonce', $elements.form.querySelector( 'input[name="nonce"]').value );
	params.set( 'search_term', query );
	params.set( 'taxonomy', $elements.form.querySelector( '#colt-search-taxonomy-selector').value );
	params.set( 'term', $elements.termSelector.value );
	params.set( 'max_results', $elements.form.querySelector( 'input[name="max_results"]').value );
	params.set( 'lang', $elements.form.querySelector( 'input[name="lang"]').value );

	url.search = params.toString();

	request.open( 'GET', url.href, true );
	request.responseType = 'json';

	$elements.results.innerHTML = '';

	if ( '' === query ) {
		return;
	}

	$elements.form.classList.add( 'search-dropdown__form--loading' );

	request.onreadystatechange = function () {
		if ( request.readyState === XMLHttpRequest.DONE ) {

			$elements.form.classList.remove( 'search-dropdown__form--loading' );

			let response = request.response;
			
			if ( ! response.hasOwnProperty( 'results' ) ) {
				return;
			}

			let total   = response.total;
			let results = response.results;

			if ( total <= 0 ) {
				return;
			}

			populateLiveResults( results );

		}
	};

	request.send();

};

const populateLiveResults = ( results ) => {
	let template = $elements.resultTemplate.innerHTML;

	if ( ! results.length ) {
		return;
	}

	let $buffer = document.createElement( 'div' );

	results.forEach(
		( result ) => {
			let resultMarkup = template;

			resultMarkup      = resultMarkup.replace( '{ permalink }', result.permalink );
			resultMarkup      = resultMarkup.replace( '{ title }', result.title );
			$buffer.innerHTML = resultMarkup.trim();

			$elements.results.append( $buffer.firstChild );
		}
	)
};

const setupColtSearch = () => {

	if ( ! $elements.component ) {
		return;
	}

	$elements.trigger.addEventListener( 'click', handleSearchDropdown );
	document.addEventListener( 'click', maybeCloseSearchDropdown );

	if ( ! $elements.results || ! $elements.resultTemplate ) {
		return;
	}

	$elements.input.addEventListener(
		'keyup',
		debounce( triggerAjaxSearch, MS_LIVE_SEARCH_DELAY )
	);

	$elements.termSelector.addEventListener( 'change', triggerAjaxSearch );

};

export {
	setupColtSearch,
};